import { GifResult, GifsResult, PaginationOptions } from '@giphy/js-fetch-api'
import appendQuery from 'append-query'
import { getResults, API_URL, WEB_API_KEY, MOBILE_API_KEY } from '.'
import isMobile from 'shared/util/is-mobile'

const trendingUrl = `${API_URL}videos/trending`
const videoUrl = `${API_URL}videos`

export const trending = (params: PaginationOptions = {}, pingbackId: string) =>
    getResults(
        appendQuery(trendingUrl, {
            api_key: isMobile() ? MOBILE_API_KEY : WEB_API_KEY,
            pingback_id: pingbackId,
            ...params,
        })
    ) as Promise<GifsResult>

export const video = (id: number) => {
    return getResults(
        appendQuery(`${videoUrl}/${id}`, {
            api_key: isMobile() ? MOBILE_API_KEY : WEB_API_KEY,
        })
    ) as Promise<GifResult>
}
